"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDevelopmentInfoToWindow = addDevelopmentInfoToWindow;
function addDevelopmentInfoToWindow(developmentInfo) {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.ori) {
    window.ori = {};
  }
  window.ori = {
    ...window.ori,
    developmentInfo
  };
}
